<div class="scene" #scene>
  <div class="sky"><div class="hex"></div></div>

  <div class="stars" aria-hidden="true">
    <span class="star" *ngFor="let s of stars"
          [class.big]="s.big"
          [style.left.%]="s.x" [style.top.%]="s.y"
          [style.animation-duration]="s.duration" [style.animation-delay]="s.delay"></span>
  </div>

  <svg class="ridge far" viewBox="0 0 2000 100" preserveAspectRatio="none" aria-hidden="true">
    <defs>
      <linearGradient id="login-ridge-far" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#343841"/><stop offset="1" stop-color="#22252c"/>
      </linearGradient>
    </defs>
    <path [attr.d]="ridgeFar" fill="url(#login-ridge-far)"/>
  </svg>
  <svg class="ridge near" viewBox="0 0 2000 100" preserveAspectRatio="none" aria-hidden="true">
    <defs>
      <linearGradient id="login-ridge-near" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#1c1e23"/><stop offset="1" stop-color="#121317"/>
      </linearGradient>
    </defs>
    <path [attr.d]="ridgeNear" fill="url(#login-ridge-near)"/>
  </svg>

  <div class="ground"><div class="road" #road></div></div>
  <div class="fog"></div>

  <div class="car-wrap" (click)="pop()">
    <div class="car">
      <div class="shadow"></div>
      <div class="refl"></div>
      <img #carImg src="assets/img/login/car-exausts.png" alt="">
      <div class="wheel l"><div class="spokes"></div></div>
      <div class="wheel r"><div class="spokes"></div></div>
      <div class="tail"></div>
      <div class="flash"></div>
    </div>
  </div>

  <canvas class="fx" #fx aria-hidden="true"></canvas>
</div>
